export const PEOPLE_MODAL_FILTERS_TEAMS = "PEOPLE_MODAL_FILTERS_TEAMS";
export const PEOPLE_MODAL_FILTERS_SHAREHOLDERS_STATUS =
  "PEOPLE_MODAL_FILTERS_SHAREHOLDERS_STATUS";
